import React from "react";
import { BarChart, Bar, XAxis, YAxis, CartesianGrid, Tooltip } from "recharts";
import reportAPI from "../../../../api/report";
import { ButtonExcel } from "../../../../utils/buttonLoadExcel";
import { ExcelReasonByStatus } from "../../functions/Report.ExportReasonStatus";
import { formatReasonByStatus } from "../../utils/Report.Format";
import {
  FLEXDROPDOWN,
  SCREENIPAD,
  STYLEBODY,
  STYLEHEAD,
  TABLE,
} from "../../../../utils/useStyle";
import DropdownReport from "../../report.dropdwn";
import { GenerateOptionsYear } from "../../../../components/functions/Functions";

const optionsYear = GenerateOptionsYear();

const DropdownFollows = ({ year, setYear }) => {
  return (
    <div>
      <DropdownReport
        title={"ปี"}
        options={optionsYear}
        value={year}
        setValue={setYear}
      />
    </div>
  );
};

const ReportReasonBystatus = ({ userDept }) => {
  const [loading, setLoading] = React.useState(false);
  const [year, setYear] = React.useState({
    label: "ทุกปี",
    value: "ALL",
  });

  const [data, setData] = React.useState({
    alive: 0,
    dead: 0,
    total: 0,
    alivePercent: 0,
    deadPercent: 0,
    checkStatusTask: [],
  });

  React.useEffect(() => {
    // Use backend API instead of frontend processing
    const fetchData = async () => {
      try {
        const response = await reportAPI.getReasonByStatusReport({
          year: String(year?.value),
          user_department: userDept,
        });
        if (response?.success) {
          setData(response.data);
        }
      } catch (error) {
        console.error("Error fetching reason by status report:", error);
      }
    };
    fetchData();
  }, [year, userDept]);

  const listTable = [
    { name: "Alive", count: data?.alive },
    { name: "Deceased", count: data?.dead },
  ];

  const CustomTooltip = ({ active, payload, label }) => {
    if (active && payload && payload.length) {
      const count = payload?.[0]?.value || 0;

      const percentage = ((count * 100) / data.total).toFixed(1);

      return (
        <div className="bg-gray-50 text-gray-700 text-sm px-2 py-1 rounded">
          <p className="label">{`Left : ${count} (${percentage}%)`}</p>
        </div>
      );
    }

    return null;
  };

  const renderCustomLabel = (props) => {
    const { x, y, width, height, value } = props;
    const percentage = ((value / data?.total) * 100).toFixed(1) + "%";
    const insideBarPosition = y + height / 2;

    return (
      <g>
        <text
          x={x + width / 2}
          y={insideBarPosition}
          fill="#111827"
          textAnchor="middle"
          dominantBaseline="middle"
        >
          {`${value} (${percentage})`}
        </text>
      </g>
    );
  };

  console.log("ReportReason", data);

  return (
    <div className="">
      <div className={``}>
        <div className="my-20">
          <>
            <div className={SCREENIPAD}>
              <div className={STYLEHEAD}>
                จำนวนสถานะผู้ป่วยที่ถอดสายแล้ว
                <div className={STYLEBODY}>ของปี "{year.label}"</div>
              </div>
              <div className={FLEXDROPDOWN}>
                <DropdownFollows year={year} setYear={setYear} />
                <ButtonExcel
                  text={"DOWNLOAD EXCEL"}
                  onClick={() => {
                    ExcelReasonByStatus(
                      formatReasonByStatus(data),
                      year,
                      setLoading
                    );
                  }}
                  loading={loading}
                />
              </div>
            </div>
            <div className={TABLE}>
              <BarChart
                width={750}
                height={300}
                data={listTable}
                margin={{
                  top: 20,
                  bottom: 2,
                }}
              >
                <CartesianGrid strokeDasharray="2 2" />
                <XAxis dataKey="name" />
                <YAxis />
                <Tooltip content={<CustomTooltip />} />
                <Bar label={renderCustomLabel} dataKey="count" fill="#99CC99" />
              </BarChart>
            </div>
          </>
        </div>
      </div>
    </div>
  );
};

export default ReportReasonBystatus;
